export const getCampaignFormValues = (campaign, defaults = {}) => {
  let rules = campaign.rules;
  if (typeof rules === "string") {
    try {
      rules = JSON.parse(rules);
    } catch {
      throw new Error(
        "Unable to read this campaign's earning rules. Please reload the campaign."
      );
    }
  }
  if (rules != null && (typeof rules !== "object" || Array.isArray(rules))) {
    throw new Error(
      "Unable to read this campaign's earning rules. Please reload the campaign."
    );
  }
  return {
    ...campaign,
    rules: { ...defaults, ...rules },
    budget: campaign.budget_paise / 100,
    reason: "",
  };
};
